/**
 * The three economic resources the Market can exchange. Never
 * energy/ozone/scrap — see `packages/shared/src/types/resource.types.ts`
 * for the full `ResourceType` union this is a subset of. The single source
 * of truth for this triple — `TradeResourcesSchema`'s `from`/`to` enum
 * (`schemas/planet.schemas.ts`) and `TradeCenterPage`'s resource pickers
 * both derive from this array rather than re-declaring the three literals.
 */
export const TRADEABLE_RESOURCES = ["metal", "minerals", "gas"];
//# sourceMappingURL=trade.types.js.map